import type { AdminUser } from "@features/users/api";
import { getPrimaryContact } from "@shared/directoryUsers";

const USER_KEY = "acweb_user";
const EMAIL_KEY = "acweb_user_email";
export const USER_EMAIL_EVENT = "acweb:user-email";
export const USER_EVENT = "acweb:user";

const isBrowser = typeof window !== "undefined" && typeof localStorage !== "undefined";

export const persistAuthUser = (user?: AdminUser) => {
  if (!isBrowser) {
    return;
  }
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    const email = getPrimaryContact(user, "email");
    setStoredUserEmail(email);
  } else {
    localStorage.removeItem(USER_KEY);
    setStoredUserEmail(undefined);
  }
  window.dispatchEvent(new Event(USER_EVENT));
};

export const setStoredUserEmail = (email?: string | null) => {
  if (!isBrowser) {
    return;
  }
  if (email?.trim()) {
    localStorage.setItem(EMAIL_KEY, email.trim());
  } else {
    localStorage.removeItem(EMAIL_KEY);
  }
  window.dispatchEvent(new Event(USER_EMAIL_EVENT));
};

export const getStoredUserEmail = (): string | undefined => {
  if (!isBrowser) {
    return undefined;
  }
  return localStorage.getItem(EMAIL_KEY) ?? undefined;
};

export const clearStoredUser = () => {
  if (!isBrowser) {
    return;
  }
  localStorage.removeItem(USER_KEY);
  setStoredUserEmail(undefined);
  window.dispatchEvent(new Event(USER_EVENT));
};

export const getStoredUser = (): AdminUser | undefined => {
  if (!isBrowser) {
    return undefined;
  }
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) {
    return undefined;
  }
  try {
    return JSON.parse(raw) as AdminUser;
  } catch {
    return undefined;
  }
};
